import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  RISK_LEVEL_1,
  RISK_LEVEL_2,
  RISK_LEVEL_3,
  RISK_LEVEL_4,
  RISK_LEVEL_5,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { firstSiteImplementationParams } from './first-site-implementation-params';
import { firstSiteImplementationBParams } from './first-site-implementation-b-params';
import { testingStatus } from './testing-status';
import { acceptanceSignOff } from './acceptance-sign-off';
import { isRegressionPossible } from './is-regression-possible';
import { regressionPlanTested } from './regression-plan-tested';
import { changeScopeTechnology } from './change-scope-technology';
import { changeScopeDomain } from './change-scope-domain';
import { cisAffectedResilient } from './cis-affected-resilient';
import { serviceOutageRequired } from './service-outage-required';
import { serviceOutageRequiredForRegressionActivity } from './service-outage-required-for-regression-activity';
import { serviceOutageDuration } from './service-outage-duration';
import { changeImpactTechnologyRecoverPlan } from './change-impact-technology-recovery-plans';
// import { whyNoChangeInTechnologyRecoveryPlans } from './why-no-change-in-technology-recovery-plans';

const riskLevelQuestions = [
  firstSiteImplementationParams.id,
  firstSiteImplementationBParams.id,
  testingStatus.id,
  acceptanceSignOff.id,
  isRegressionPossible.id,
  regressionPlanTested.id,
  changeScopeTechnology.id,
  changeScopeDomain.id,
  cisAffectedResilient.id,
  changeImpactTechnologyRecoverPlan.id,
  // whyNoChangeInTechnologyRecoveryPlans.id,
  serviceOutageRequired.id,
  serviceOutageRequiredForRegressionActivity.id,
  serviceOutageDuration.id,
];

const riskLevelQuestionsByFieldId = {
  [firstSiteImplementationParams.id]: firstSiteImplementationParams,
  [firstSiteImplementationBParams.id]: firstSiteImplementationBParams,
  [testingStatus.id]: testingStatus,
  [acceptanceSignOff.id]: acceptanceSignOff,
  [isRegressionPossible.id]: isRegressionPossible,
  [regressionPlanTested.id]: regressionPlanTested,
  [changeScopeTechnology.id]: changeScopeTechnology,
  [changeScopeDomain.id]: changeScopeDomain,
  [cisAffectedResilient.id]: cisAffectedResilient,
  [changeImpactTechnologyRecoverPlan.id]: changeImpactTechnologyRecoverPlan,
  // [whyNoChangeInTechnologyRecoveryPlans.id]: whyNoChangeInTechnologyRecoveryPlans,
  [serviceOutageRequired.id]: serviceOutageRequired,
  [serviceOutageRequiredForRegressionActivity.id]: serviceOutageRequiredForRegressionActivity,
  [serviceOutageDuration.id]: serviceOutageDuration,
};


const riskOneScore = 1.38;
const riskTwoScore = 1.93;
const riskThreeScore = 3.25;
const riskFourScore = 4;
const riskFiveScore = 5;


const riskOne = (riskScore) => {
  if (riskScore > riskOneScore) {
    return false;
  }
  return true;
};

const riskTwo = (riskScore) => {
  if (riskScore > riskTwoScore) {
    return false;
  }
  return true;
};

const riskThree = (riskScore) => {
  if (riskScore > riskThreeScore) {
    return false;
  }
  return true;
};

const riskFour = (riskScore) => {
  if (riskScore > riskFourScore) {
    return false;
  }
  return true;
};

const riskFive = (riskScore) => {
  if (riskScore > riskFiveScore) {
    console.warn(`THE CALCULATED RISK SCORE IS ABOVE ${riskFiveScore} WHICH SHOULD NOT BE POSSIBLE`);
    return false;
  }
  return true;
};

const getRiskValue = (riskScore) => {
  if (riskOne(riskScore)) {
    return RISK_LEVEL_1;
  }
  if (riskTwo(riskScore)) {
    return RISK_LEVEL_2;
  }
  if (riskThree(riskScore)) {
    return RISK_LEVEL_3;
  }
  if (riskFour(riskScore)) {
    return RISK_LEVEL_4;
  }
  if (riskFive(riskScore)) {
    return RISK_LEVEL_5;
  }
  // This should NEVER happen, but if it does it's best to set the risk score to 5 than not have a risk score
  return RISK_LEVEL_5;
};


const calculateRiskLevel = (dataByFieldId) => {

  const deleteThisInTheNearFuture = {};

  const riskLevels = riskLevelQuestions.map((riskLevelQuestion) => {
    const formField = riskLevelQuestionsByFieldId[riskLevelQuestion];

    const {
      fieldType,
      riskLevelParams,
    } = formField;

    const value = fieldType === VF_BUTTON_SELECTOR ? dataByFieldId[riskLevelQuestion].value[0] : dataByFieldId[riskLevelQuestion].value;
    let riskScore = riskLevelParams.score[value];
    const riskWeight = riskLevelParams.weight;
    if (riskScore === undefined && (riskLevelQuestion === 'first_site_implementation' || riskLevelQuestion === 'first_site_implementation_b' || riskLevelQuestion === 'acceptance-sign-off')) {
      riskScore = 1;
    }
    if (riskScore === undefined && riskLevelQuestion === 'testing-status') {
      riskScore = 2;
    }
    deleteThisInTheNearFuture[riskLevelQuestion] = riskLevelParams;

    if (riskScore === undefined) {
      console.warn('WARNING, A VALUE IS MISSING IN CALCULATE RISK LEVEL');
    }

    return riskScore * riskWeight;

  });

  const riskWeights = riskLevelQuestions.map((riskLevelQuestion) => riskLevelQuestionsByFieldId[riskLevelQuestion].riskLevelParams.weight);

  const sumOfRisk = riskLevels.reduce((a, b) => a + b, 0);
  const sumOfRiskWeights = riskWeights.reduce((a, b) => a + b, 0);
  const calculatedRisk = sumOfRisk / sumOfRiskWeights;
  const riskValue = getRiskValue(calculatedRisk);


  // just putting this here for now to easilly check that I have the risk scores/weight correct
  console.log('Risk Questionnaire Scores:');
  console.log(deleteThisInTheNearFuture);
  console.log('Sum of Risk: (A1*W1)+(A2*W2) ect ect');
  console.log(sumOfRisk);
  console.log('Sum of risk weights (W1+W2) ect ect (this may be off by a super tiny amount due to jasvscript)');
  console.log(sumOfRiskWeights);
  console.log('Calculated Risk: Sum of Risk/Sum of risk weights');
  console.log(calculatedRisk);
  console.log('Risk Value');
  console.log(riskValue);
  return riskValue;
};


export { calculateRiskLevel };
